// extracted by mini-css-extract-plugin
export var firstGlow = "styles-module--first-glow--c89d3";
export var image = "styles-module--image--0534a";
export var mainContent = "styles-module--mainContent--9d451";
export var paragraph = "styles-module--paragraph--bd587";
export var title = "styles-module--title--68603";